import axios from "@/plugins/axios";

import carts from "./carts";
import center from "./center";
import destinations from "./destinations";
import gshop from "./gshop";
import inquiries from "./inquiries";
import likes from "./likes";
import orders from "./orders";
import points from "./points";
import purchases from "./purchases";
import reviews from "./reviews";
import templates from "./templates";

let url = "/api/v1/me";

export default {
    get() {
        return axios.get(`${url}/info`).then((result) => result.data);
    },
    put(data) {
        return axios.put(`${url}/info`, data).then((result) => result.data);
    },
    verify(data) {
        return axios.post(`${url}/verify`, data).then((result) => result.data);
    },
    withdraw(data) {
        return axios.post(`${url}/withdraw`, data).then((result) => result.data);
    },

    carts,
    center,
    destinations,
    gshop,
    inquiries,
    likes,
    orders,
    points,
    purchases,
    reviews,
    templates
};
